import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "display"]
  static values = { min: Number, max: Number }

  connect() {
    this.count()
  }

  count() {
    const length = this.inputTarget.value.length
    const remaining = this.minValue - length

    if (length === 0) {
      this.displayTarget.textContent = `0 / ${this.maxValue}`
      this.displayTarget.className = "text-xs text-gray-400"
    } else if (remaining > 0) {
      this.displayTarget.textContent = `${remaining} more needed`
      this.displayTarget.className = "text-xs text-gray-500"
    } else if (length > this.maxValue) {
      this.displayTarget.textContent = `${length - this.maxValue} over limit`
      this.displayTarget.className = "text-xs text-red-500"
    } else {
      this.displayTarget.textContent = `${length} / ${this.maxValue}`
      this.displayTarget.className = "text-xs text-green-600"
    }
  }
}
